import React from 'react'
import Data from '../Data/Price.json'

const Price = () => {
  return (
    <div style={{backgroundColor:'#c7defa'}}>
      {/* Hero Section =================*/}
      <div style={{ position: 'relative', width: '100%', height: '70vh' }}>
          <img
            src="/image/bg4.jpg" alt="Hotel" className="img-fluid" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          
          {/* Black semi-transparent overlay */}
          <div style={{
            position: 'absolute',
            top: 0, left: 0,
            width: '100%', height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // 0.4 মানে হালকা কালো
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontSize: '3rem',
            fontWeight: 'bold'
          }}>
             Price Grid
          </div>
        </div>
      {/* price section ================*/}
       <div className="container my-4" >
        <div className="row d-flex  flex-wrap justify-content-center  ms-5">
          <h3 className='pt-4'>AR Brothers Luxury Rooms</h3>
          <h1 className="display-3 pb-5">LUXURY ROOMS $ SUITES</h1>
          
          {Data.map((item, index) =>(
           <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4  d-flex">
            <div className='card  bg-secondary  ' style={{padding:'50px  '}}>
               <h3>{item.h} </h3>
               <h4><span className='fs-1'>{item.i}</span>  <span>{item.j} </span> </h4>
            <ul className='text-start pt-4' >
              <li>{item.a} </li>
              <li>{item.b} </li>
              <li>{item.c} </li>
              <li>{item.d} </li>
              <li>{item.e} </li>
              <li>{item.f} </li>
            </ul>
              <button className="btn btn-info mt-4 p-3">BOOK NOW</button>
            </div>
           
          </div>
        ))}
        </div>
    </div>
    </div>
   
  )
}

export default Price
